export default {
  'menu.system': 'Manajemen Sistem',
  'menu.system.user': 'Manajemen Pengguna',
  'menu.system.role': 'Manajemen Peran',
  'menu.system.menu': 'Manajemen Menu',
  'menu.system.dept': 'Manajemen Departemen',
  'menu.monitor': 'Monitor',
  'menu.monitor.login-log': 'Log Masuk',
  'menu.monitor.oper-log': 'Log Operasi',
  'menu.login': 'Masuk',
};
